import { Theme } from '@mui/material';
/**
 * Styling for custom workspace iframe component
 * @returns custom workspace component CSS properties as a JSON object
 * @example customworkspaceStyles
*/
const customworkspaceStyles = (theme: Theme) => {
  const styles = {
    iframeContainer: {
      height: '100%',
      width: '100%',
      border:`1px solid ${theme.palette.border.main}`,
      boxShadow: `0px 1px 3px ${theme.palette?.boxshadow?.main}`,
      borderRadius:'6px',
      '.customworkspace-iframe': {
        border:`1px ${theme.palette.border.main}`,
        height: 'calc(100% - 54px)',
      },
      '.messageText':{
        fontSize: '1rem',
        fontWeight: '600',
        color: theme.palette.text.secondary,
        lineHeight:'1.5',
        padding:'10px',
      },
      '.link_text':{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '.link':{
        marginRight: '4px',
        cursor: 'pointer',
        borderBottom: '1px solid gray',
      },
    },
    customWorkspaceHeader: { 
      borderBottom: `1px solid ${theme.palette.border.main}`,
    },
    customDropdown: {
      m: 1, 
      minWidth: 120, 
      minHeight:30, 
      marginTop:1,
    },
    openinnewtabIcon: {
      marginRight: 2.5, 
      marginTop: 0.7,
    },
    openinnewTabButton:{
      width:5,
    },
    openInNewWindowContainer:{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '120px 10px',
      padding: '10px',
      textAlign: 'center',
    },
    openInNewWindowIcon:{
      padding: '5px',
    },
    openInNewWindowContent:{
      padding: '5px',
    },
  }
  return styles
}

export default customworkspaceStyles